import { Charge } from '@/types/charge';
import { CHARGE_STATUS } from '@/types/charge-status';
import { parseDateOnly } from '@/utils/format-date';
import { isBefore, startOfToday } from 'date-fns';

/** Cobranças que o cliente ainda precisa resolver. */
export const OPEN_CHARGE_STATUSES = [CHARGE_STATUS.PENDING, CHARGE_STATUS.OVERDUE];

export function isChargeOpen(charge: Pick<Charge, 'status'>): boolean {
  return OPEN_CHARGE_STATUSES.includes(charge.status);
}

/**
 * Atrasada = em aberto E vencimento ANTES de hoje.
 * Vencimento hoje ainda é "Pendente" — o cliente tem o dia todo para pagar.
 */
export function isChargeOverdue(charge: Pick<Charge, 'status' | 'dueDate'>): boolean {
  if (!isChargeOpen(charge)) return false;
  if (charge.status === CHARGE_STATUS.OVERDUE) return true;

  const dueDate = parseDateOnly(charge.dueDate);
  if (!dueDate) return false;
  return isBefore(dueDate, startOfToday());
}

/** Status efetivo para exibição: converte PENDING vencida em OVERDUE. */
export function getEffectiveChargeStatus(
  charge: Pick<Charge, 'status' | 'dueDate'>,
): CHARGE_STATUS {
  return isChargeOverdue(charge) ? CHARGE_STATUS.OVERDUE : charge.status;
}

/** Primeira cobrança em aberto (mais antiga por vencimento), se houver. */
export function getNextOpenCharge(charges: Charge[] | undefined | null): Charge | null {
  if (!charges || charges.length === 0) return null;
  return (
    [...charges]
      .filter(isChargeOpen)
      .sort((a, b) => {
        const aTime = parseDateOnly(a.dueDate)?.getTime() ?? 0;
        const bTime = parseDateOnly(b.dueDate)?.getTime() ?? 0;
        return aTime - bTime;
      })[0] ?? null
  );
}
